module.exports = __webpack_public_path__ + "media/donate/shared/trust_logos/paypal-63c8a5ac58ee1419390be6d796dcd9fb.svg";